export default __webpack_public_path__ + "static/banner_connpass_20230928-d9b6217c9d173a35c8e3b53a7d31ca64.png";